import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';
import { phoneCodesCountries } from '../../../../config';

const paymentDetails = (state) => state.paymentDetails.list;

export const getHeaderNames = createSelector(
    () => {
        const detailsNames = UserStore.getTranslation().paymentPage.details;
        const tipsNames = UserStore.getTranslation().dataTable.headers;
        return [
            detailsNames.account,
            tipsNames.status,
            detailsNames.type,
            tipsNames.currency,
            detailsNames.accountInfo,
            detailsNames.created,
            detailsNames.edited,
            tipsNames.actions
        ];
    }
);

export const getPaymentDetails = createSelector(
    paymentDetails,
    (paymentDetails = []) => {
        return paymentDetails;
    }
);

export const getCountries = createSelector(
    () => {
        const countriesName = UserStore.getTranslation().countries;
        let list = [];

        phoneCodesCountries.map((item) => {
            list.push({
                ...item,
                title: countriesName[item.code]
            });
        });

        return list;
    }
);
